import '../scss/styles.scss';
import './scripts.js'



// WEBPACK FOOTER //
// ./assets/src/js/app.js